import { Component, inject, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarDataModel } from '@alf-nx-workspace/shared/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EbenTaskDetail } from '@alf-nx-workspace/eben/interfaces';
import { ProcessInstance } from '@alfresco/adf-process-services';

@Component({
  selector: 'shared-ui-snackbar',
  templateUrl: './process-instance-cancel-success.component.html',
  styleUrls: ['./process-instance-cancel-success.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule, MatButtonModule, MatProgressBarModule]
})
export class ProcessInstanceCancelSuccess {

  snackBarRef = inject(MatSnackBarRef);

  duration: number;
  showProgressBar = false;
  progressValue = 0;

  title = 'SNACKBAR.PROCESS_CANCEL.SUCCESS.TITLE';

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarDataModel) {
    this.duration = data.duration;
  }

  ngOnInit() {
    this.showProgressForDuration();
  }

  private showProgressForDuration() {
    this.showProgressBar = true;
    this.progressValue = 100;

    const steps = this.duration / 100;
    const decrement = 100 / steps;

    const interval = setInterval(() => {
      this.progressValue -= decrement;
      if (this.progressValue <= 0) {
        this.progressValue = 0;
        clearInterval(interval);
        this.showProgressBar = false;
      }
    }, 100);
  }
}
